module.exports = __webpack_public_path__ + "static/media/3l_website_logo_coorg_wgbc.1249c8f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/3l_website_logo_coorg_wgbc.jpg
// module id = 52
// module chunks = 0